import { Injectable, EventEmitter } from '@angular/core';
import { IPlatformToolHandler } from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { MagicLinkModel, TabModel } from '@shared/models/platform-tool-models';
import { ActivatedRoute, Router } from '@angular/router';
import { PlatformCommand, ContentScope } from '@shared/commands/command-base';
import { Store } from '@ngrx/store';
import { IDac6ReporterState } from '../store/reducers/dac6-reporter.reducer';
import { ParticleService } from '@core/services/particle.service';
import { SmartGridService } from '@core/services/smart-grid.service';
import { ParticleState } from '@shared/store/reducers/particle.reduer';
import { CommandService } from '@core/services/command.service';
import { ParticleCacheService } from '@core/services/particle-cache.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { CollaborationState } from '@features/task-manager/collaboration/store/collaboration.reducer';
import { DialogService } from '@shared/services/dialog-service';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';
import { TaskManagerService } from '@features/task-manager/services/task-manager.service';
import { Dac6ReporterApiService } from './dac6-reporter.service';
import { PlatformSidebarState } from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import { FileManagementService } from '@core/services/file-management.service';
import { ProjectState } from '@features/projects/store/reducers/projects.reducer';
import { IQueryState } from '@shared/store/reducers/query.reducer';
import { TimeZoneService } from '@core/services/time-zone.service';
import { FileStoreCommonService } from '@features/file-manager/services/file-store-common.service';
import {
  SaveSelectedFilingItemsInLeftSideOfTheTransferboxCommand,
  CreateFormWithMappingCommand,
  CreateDac6DueDateOccurrencesCommand,
  UpdateFieldValueCommand,
  UpdateFilingDeadlineCommand,
  ExportDAC6Command,
  DeleteFilingItemCommand,
  ArchiveSingleCaseCommand,
  UnarchiveCaseCommand,
  ArchiveFilingItemCommand,
  SaveSelectedCaseModelsInLeftSideOfTheTransferboxCommand,
  ArchiveCaseCommand,
  CopyFilingCommand,
  CopyFilingFromExistingCaseCommand,
  DownloadFilingFormErrorReportDownloadCommand
} from '../commands/dac6-reporter.command';
import { SetActivityFeedAction, SetCurrentHelpNoteAction } from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import { DialogModel } from '@shared/models/dialog.model';
import { takeUntil, take } from 'rxjs/operators';
import { BasketProvider } from '@shared/models/basket-provider';
import { CreateChatConversationCommand } from '@features/task-manager/collaboration/store/collaboration.command';
import { CreateChatConversationAction } from '@features/task-manager/collaboration/store/collaboration.action';
import { ConversationComponentName } from '@features/task-manager/collaboration/store/collaboration.constants';
import { Subject } from 'rxjs';
import { User_Specefic_Grid_Filter, Dynamic_Grid_Data_Request_Parameters } from '@shared/store/actions/virtual-grid.actions';
import { AddReportCommand } from '@features/data-survey/commands/report.commands';
import { Configuration } from '@shared/models/configuration';
import { Dac6RoutingPlatformCommandHelper } from '@shared/components/platform-tool/routing-platform-command-helpers/dac6-routing-command-helper';
import { PlatformSidebarService } from '@shared/components/platform-sidebar/store/platform-sidebar.service';
import {Api} from "@shared/constants/common-field.constants";
@Injectable({
  providedIn: 'root'
})
export class PlatformToolDac6FilingHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter();
  activatedRoute?: ActivatedRoute;
  metaData?: any;

  filingType: string;
  sourceType: string;
  selectedTab: TabModel;
  currentTabData: any;
  unSubscribe$ = new Subject<void>();
  showArchived = false;
  exportFileName = [
    {
      key: 'Dac6MonthlyFiling.xlsx',
      value: 'Monthly Filing.xlsx'
    },
    {
      key: 'Dac6QuarterlyFiling.xlsx',
      value: 'Quarterly Filing.xlsx'
    },
    {
      key: 'Dac6YearlyFiling.xlsx',
      value: 'Annual Filing.xlsx'
    },
    {
      key: 'Dac6OtherFiling.xlsx',
      value: 'Other Filing.xlsx'
    },
    {
      key: 'Dac6ThirdPartyFiling.xlsx',
      value: 'Third Party Filing.xlsx'
    }
  ];
  tabs =  [
      {
        id: 0,
        header: 'Monthly Filing',
        index: 0,
        sourceKey : 'Dac6MonthlyFiling',
        filingType: 'monthly',
        relativeUrl: 'dac6-reporter/filing/monthly',
        createFilingComponent: 'CreateFilingDialogComponent'
      },
      {
        id: 1,
        header: 'Quarterly Filing',
        index: 1,
        sourceKey : 'Dac6QuarterlyFiling',
        filingType: 'quarterly',
        relativeUrl: 'dac6-reporter/filing/quarterly',
        createFilingComponent: 'CreateFilingDialogComponent'
      },
      {
        id: 2,
        header: 'Annual Filing',
        index: 2,
        sourceKey : 'Dac6YearlyFiling',
        filingType: 'annual',
        relativeUrl: 'dac6-reporter/filing/annual',
        createFilingComponent: 'CreateFilingDialogComponent'
      },
      {
        id: 3,
        header: 'Other Filing',
        index: 3,
        sourceKey : 'Dac6OtherFiling',
        filingType: 'other',
        relativeUrl: 'dac6-reporter/filing/other',
        createFilingComponent: 'CreateFilingDialogComponent'
      },
      {
        id: 4,
        header: 'Third Party Filing',
        index: 4,
        sourceKey : 'Dac6ThirdPartyFiling',
        filingType: 'third-party',
        relativeUrl: 'dac6-reporter/filing/third-party',
        createFilingComponent: 'CreateThirdPartyFilingDialogComponent'
      }
  ]
  constructor(private router: Router,
    private store: Store<IDac6ReporterState>,
    private particleService: ParticleService,
    private smartGridService: SmartGridService,
    private particleStore: Store<ParticleState>,
    private sideBarService: PlatformSidebarService,
    protected commandService: CommandService,
    protected particleCacheService: ParticleCacheService,
    private snackBarService: SnackBarService,
    private collaborationStore: Store<CollaborationState>,
    private dialogService: DialogService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private taskManagerService: TaskManagerService,
    private dac6RepoterApiService: Dac6ReporterApiService,
    private platformSidebarStore: Store<PlatformSidebarState>,
    private fileManagementService: FileManagementService,
    protected projectStore: Store<ProjectState>,
    private queryState: Store<IQueryState>,
    private timeZoneService: TimeZoneService,
    private fileStoreCommonService: FileStoreCommonService) { }

  executeCommand(command: PlatformCommand) {
    console.log(command);
    switch (command.name) {
      case 'CreateFilingCommand':
        this.createFiling();
        break;
      case 'StatusSettingsCommand':
        this.openStatusSettings();
        break;
      case 'ManageFieldsCommand':
        this.manageSection();
        break;
      case 'ExportCommand':
        this.export();
        break;
      case 'ArchiveCasesCommand':
        this.bulkArchive();
        break;
      case 'ShowArchivedCommand':
        this.showArchivedChanged(command);
        break;
      case 'BasketChangedCommand':
        this.onBasketChange(command.fieldValues['CurrentBasket']);
        break;
      case 'DownloadPlatformFormErrorCommand':
        this.downloadErrorReport();
        break;
      default:
        this.executeCommandToApi(command);
    }
  }
  getTabDataUsingSourceType(sourceType){
    let tab = this.tabs.filter(o => o.sourceKey === sourceType)[0];
    return tab;
  }
  getTabDataUsingFilingType(filingType){
    let tab = this.tabs.filter(o => o.filingType === filingType)[0];
    return tab;
  }

  downloadErrorReport() {
    this.fuseSplashScreenService.show();
    this.currentTabData['FormIds'].forEach(formId => {
      this.downloadErrorReportForFormId(formId);
    });
  }


  private downloadErrorReportForFormId(formId) {
    const errorReportDownloadCommand = new DownloadFilingFormErrorReportDownloadCommand(formId);
    this.commandService.executeCommand(errorReportDownloadCommand).pipe(takeUntil(this.unSubscribe$)).subscribe((commandState: any) => {
      if (commandState && !commandState.Payload.IsOption) {
        this.fileManagementService.downloadClientFileWithId(commandState.Payload.FileId).pipe(takeUntil(this.unSubscribe$)).subscribe(response => {
          if (response) {
            this.fileManagementService.openSaveFileWindow(response, commandState.Payload.FileName);
            this.fuseSplashScreenService.hide();
            this.snackBarService.showInformation('File Downloaded');
          }
        });
      }
      if (commandState && commandState.Payload.IsOption) {
        this.fuseSplashScreenService.hide();
        this.snackBarService.showError(commandState.Payload.Message);
      }
    }, error => {
      this.fuseSplashScreenService.hide();
      console.log(error);
    });
  }

  valueChanged(event: any) {
    if (event.fieldDefinition && event.fieldDefinition.key === 'Form' && event.value) {
      if (event.value.tags && event.value.tags.length) {
        const formId = event.value.tags[0];
        console.log(this.activatedRoute);
        this.router.navigate([`dac6-reporter/filing-manager/forms/${formId}`], {
          queryParams: {'arrangementGuid': event.item.cells['ArrangementGUID'].value}
        });
      } else {
        this.createForm(event.item, event.value.id);
      }

      return;
    }
    if (event.fieldDefinition && event.fieldDefinition.key === 'CaseId') {
      this.router.navigateByUrl(`dac6-reporter/overview/case/${event.item.cells['CaseGUID'].value}`);
      return;
    }

    switch (event.action.id) {
      case 'Open':
        this.router.navigateByUrl(`dac6-reporter/overview/case/${event.item.cells['CaseGUID'].value}`);
        break;
      case 'OpenCaseFolder':
        let viewDocumentCommand = new PlatformCommand('ViewDocumentActivityCommand','Dac6Api');
        var sourceKey = BasketProvider.getRootSourceKeyBySourceType(event.item.type);
        viewDocumentCommand.fieldValues['SourceType'] = sourceKey;
        // viewDocumentCommand.fieldValues[sourceKey+"Id"] = event.item.id;
        viewDocumentCommand.fieldValues['CaseId'] = event.item.id;
        this.commandService.executePlatformCommand(viewDocumentCommand).pipe(take(1)).subscribe(response => {
            console.log('commandState', response);
          },
          error => {
            console.error('Failed to basket manage section', error);
          });
        this.navigateToCaseFolder(event);
        break;

      case 'AttachTask':
        // this.attachTask(event);
        break;
      case 'OpenTask':
        // this.openTask(event);
        break;
      case 'Reset':
        this.reset(event);
        break;
      case 'Refresh':
        this.invalidateSelectedTab();
        break;
      case 'Edit':
        this.edit(event);
        break;
      case 'SetActive':
        // this.setActive(event);
        break;
      case 'Occurrances':
        // this.showOccurrances(event);
        break;
      case 'Task':
        this.showTask(event);
        break;
      case 'Start Conversation':
        this.startConversationActivity(event);
        this.getChatForThisCase(event);
        break;
      case 'CreateReport':
        this.createReport(event.item)
        break;
      case 'CreateACopy':
        this.copyFilling(event.item)
        break;
      case 'Delete':
        this.delete(event);
        break;
      case 'Archive':
        this.archiveSingle(event.item.cells['CaseGUID'].value);
        break;
      case 'UnarchiveCase':
        this.unarchiveCase(event.item.cells['CaseGUID'].value);
        break;
      case 'Copy':
        this.copyCase(event);
        break;
      case 'ViewActivity':
        this.trackCaseActiviy(event);
        break;
    }
    console.log('onGridCellValueChange', event);
  }
  setSelectedTab(selectedTab: TabModel): void {
    if(selectedTab.id === 'FormErrorReport') {
      this.currentTabData = selectedTab.tabData;
      return;
    }
    let currentSourceType = selectedTab.id;
    let actualSourceType = this.magicLinkModel.fieldValues['SourceType'];
    if(currentSourceType !== actualSourceType){
      let currentFilingType = this.getTabDataUsingSourceType(currentSourceType).filingType;
      this.navigateToFiling(currentFilingType);
    } else {
      this.setAppropiateTab(selectedTab);
    }
  }
  showHelpNoteSidebarIcon(selectedTab) {
    this.sideBarService.showSidebarIcon('Details');
    let helpNoteId = 'dac6-filing';
    const helpNoteObj = this.getHelpNoteObject(helpNoteId);
    this.platformSidebarStore.dispatch(new SetCurrentHelpNoteAction(helpNoteObj));
  }

  private getHelpNoteObject(helpNoteId) {
    let helpNoteObj = {};
    helpNoteObj['helpNoteId'] = helpNoteId;
    return helpNoteObj;
  }

  setAppropiateTab(selectedTab: TabModel){
    this.filingType = this.magicLinkModel.fieldValues['FilingType'];
    this.sourceType = this.magicLinkModel.fieldValues['SourceType'];
    this.selectedTab = selectedTab;
    this.currentTabData = selectedTab.tabData;
    this.showHelpNoteSidebarIcon(selectedTab);
  }
  destroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
  private navigateToFiling(filingType: string) {
    this.router.navigateByUrl('dac6-reporter/filing/' + filingType);
  }
  private invalidateSelectedTab() {
    this.invalidateSubject.invalidate();
  }
  onTabIndexChange($event) {
    // const tab = this.tabs[this.currentBasketId][$event];
    // this.navigateToFiling(tab.filingType);
  }
  createForm(filingItem: any, templateId: string) {
    let selectionKey = 'create-form-with-mapping';
    let preCommand = new SaveSelectedFilingItemsInLeftSideOfTheTransferboxCommand(selectionKey, filingItem.id);
    this.commandService.executeCommand(preCommand).subscribe(prestate=>{
      if(prestate){
        this.openTransferboxToCreateFiling(filingItem, selectionKey, templateId);
      }
    });
  }
  private trackCaseActiviy(event: any) {
    this.platformSidebarStore.dispatch(new SetActivityFeedAction({type: 'ReferenceCode', id: event.item.cells['ReferenceCode'].value, title: event.item.cells['CaseId'].value, isDefault: false, isUserAction: true}));
  }
  openTransferboxToCreateFiling(filingItem: any,  selectionKey: string, templateId: string){
    let input = {
      ['SELECTION_KEY'] : selectionKey,
      ['SOURCE_TYPE']: this.sourceType,//this.selectedTab.sourceKey, // will be get from magic link
      ['FILING_ITEM_ID']: filingItem.id,
      ['ITEM_ID']: filingItem.id
    };
    let filterId = `${selectionKey}${filingItem.id}`;
    const dialogModel = DialogModel.create('Select', 'EntitySelectorDialogComponent', {
      filterId: filterId,
      filterTemplateId: 'create-form-filter',
      apiKey: 'Dac6Api',
      input: input
    });
    dialogModel.minWidth = '80%';
    dialogModel.maxWidth = '1500px';

    this.dialogService.showOkCancelDialog(dialogModel)
      .subscribe(actionState => {
        if (actionState && actionState.action === 'OK') {
          let command = new CreateFormWithMappingCommand(filterId, selectionKey, filingItem.id, templateId);
          this.fuseSplashScreenService.show();
          this.commandService.executeCommand(command).subscribe(state => {
            this.fuseSplashScreenService.hide();
            this.router.navigate([`dac6-reporter/filing-manager/forms/${state.Payload}`]);
          });
        }
      });
  }

  startConversationActivity(event)
  {
    let viewDocumentCommand = new PlatformCommand('OpenConversationActivityCommand','Dac6Api');
    var sourceKey = BasketProvider.getRootSourceKeyBySourceType(event.item.type);
    viewDocumentCommand.fieldValues['SourceType'] = sourceKey;
    // viewDocumentCommand.fieldValues[sourceKey+"Id"] = event.item.id;
    viewDocumentCommand.fieldValues['CaseId'] = event.item.id;
    this.commandService.executePlatformCommand(viewDocumentCommand).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }
  getChatForThisCase(event) {
    console.log('on filinn', event);
    const sourceInfoDictionary = {
      'sourceInfoDictionary': {
        CaseGuid: event.item.cells['CaseId'].value,
        caseId: event.item.cells['CaseId'].displayText
      }
    };
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      `${event.item.cells['CaseId'].displayText}`,
      true,
      0,
      'DAC6',
      [],
      true,
      event.item.cells['CaseId'].value,
      sourceInfoDictionary
    );
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }

  showTask(event) {
    if (event.item.cells[event.fieldDefinition.key]
      && event.item.cells[event.fieldDefinition.key].value
      && event.item.cells[event.fieldDefinition.key].value.taskId) {
      this.taskManagerService.openTaskByTaskId(event.item.cells[event.fieldDefinition.key].value.taskId, 'COMPANY').subscribe(state => {
        if(state){
          const value = event.fieldDefinition.dataType === 'Boolean' ? this.getBoolean(event.item.cells[event.fieldDefinition.key].value) : event.item.cells[event.fieldDefinition.key].value;
          if(state.card && state.card.status && value.hasOwnProperty('taskStatus')){
              value.taskStatus = state.card.status;
          }
          if(state.card && state.card.title && value.hasOwnProperty('taskTitle')){
            value.taskTitle = state.card.title;
          }
          let displayFieldValue = '';
          if(event.item.cells[`${event.fieldDefinition.key}DisplayText`]){
            displayFieldValue = event.item.cells[`${event.fieldDefinition.key}DisplayText`];
          }
          this.updateFieldValue(event.item.id, event.fieldDefinition.key, value, displayFieldValue);
        }
        else {
           this.invalidateSelectedTab();
        }
      });
    } else {
      this.fuseSplashScreenService.show();
      const command = new CreateDac6DueDateOccurrencesCommand(event.item.id, event.fieldDefinition.key, event.fieldDefinition.header, null);
      this.commandService.executeCommand(command)
        .pipe().subscribe(commandState => {
        this.invalidateSelectedTab();
        this.fuseSplashScreenService.hide();
      });
    }
  }

  manageFields() {
    this.router.navigateByUrl(`dac6-reporter/filing/manage-section/${this.sourceType}`);
  }
  openStatusSettings() {
    this.dac6RepoterApiService.getDac6BoardId().pipe(takeUntil(this.unSubscribe$)).subscribe((selectedBoardId: any) => {
      if (selectedBoardId) {
        this.taskManagerService.openTaskStatusSettings(selectedBoardId, 1).pipe(takeUntil(this.unSubscribe$)).subscribe(xx => {
          this.invalidateSelectedTab();
        });
      }
    });
  }
  edit(event: any) {
    if(event.fieldDefinition.key === 'FilingAttachment'){
      event.fieldDefinition.metaData['DirectoryPath'] =
        event.fieldDefinition.metaData['DirectoryPath'].replace('[CASE_ID]',event.item.cells['CaseId'].value);
    }
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, '600px', '600px', this.sourceType)//this.selectedTab.sourceKey) magic link
      .subscribe(state => {
        console.log('After Edit', state);
        if (state.action === 'OK') {
          if (event.fieldDefinition.key === 'DAC6FilingDeadline') {
            const value = event.item.cells[event.fieldDefinition.key].value.dueDate;
            const command = new UpdateFilingDeadlineCommand(event.item.id, event.fieldDefinition.key, value);
            this.commandService.executeCommand(command).pipe().subscribe(commandState => {
              console.log(commandState);
              this.invalidateSelectedTab();
            });
          } else {
            const value = event.fieldDefinition.dataType === 'Boolean' ? this.getBoolean(event.item.cells[event.fieldDefinition.key].value) : event.item.cells[event.fieldDefinition.key].value;
            let displayFieldValue = '';
            if(event.item.cells[`${event.fieldDefinition.key}DisplayText`]){
              displayFieldValue = event.item.cells[`${event.fieldDefinition.key}DisplayText`];
            }
            this.updateFieldValue(event.item.id, event.fieldDefinition.key, value, displayFieldValue);
          }
        }
      });
  }

  updateFieldValue(filingId: string, fieldKey: string, value: any, displayText: string){
    const command = new UpdateFieldValueCommand(filingId, fieldKey, value, displayText);
    this.commandService.executeCommand(command).pipe().subscribe(commandState => {
      console.log(commandState);
      this.invalidateSelectedTab();
    });
  }

  getBoolean(value: string) {
    return value === 'true' || value === 'Yes' || value === 'yes';
  }
  export() {
    const sourceType = this.sourceType;//this.selectedTab.sourceKey magic link;
    this.fuseSplashScreenService.show();
    const filtersObject = this.particleCacheService.getUserPreferenceGridSetting(User_Specefic_Grid_Filter, sourceType);
    const filters = Object.values(filtersObject);
    const parametersObject = this.particleCacheService.getUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, sourceType);
    this.commandService.executeCommand(new ExportDAC6Command(sourceType, filters, parametersObject)).subscribe(response => {
      this.fileManagementService.downloadClientFileWithId(response.Payload.FileId).subscribe(payload => {
        this.fuseSplashScreenService.hide();
        const exportFileName = this.exportFileName.find(item=>item.key === response.Payload.FileName).value;
        this.fileManagementService.openSaveFileWindow(payload, exportFileName);
      });
    });
  }

  reset(event: any) {
    const command = new UpdateFilingDeadlineCommand(event.item.id, event.fieldDefinition.key, null);
    this.commandService.executeCommand(command).pipe().subscribe(commandState => {
      console.log(commandState);
      this.invalidateSelectedTab();
    });
  }

  delete(event: any) {
    this.fuseSplashScreenService.show();
    const command = new DeleteFilingItemCommand(event.item.id);
    this.commandService.executeCommand(command).pipe().subscribe(commandState => {
      console.log(commandState);
      this.invalidateSelectedTab();
      this.fuseSplashScreenService.hide();
    });
  }

  archiveSingle(caseGuid: string) {
    const dialogModel = DialogModel.create('Archive Case',
      'ArchiveDialogComponent',
      {}, '500px', '490px', false);
    dialogModel.okCaption = "Archive";
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(data => {
      if (data.action === 'OK') {
        console.log(data.data.input['comment']);
        let command = new ArchiveSingleCaseCommand(caseGuid, data.data.input['comment']);
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).subscribe(state => {
          this.invalidateSelectedTab();
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }
  unarchiveCase(caseGuid: string) {
    const message = "You can unarchive this Case if you need to make additional edits, or if it was archived by mistake. Please ensure that any associated Tasks and Reports are updated and re-opened as required.";
    const question = "Are you sure you want to unarchive this DAC6 Case?";
    this.dialogService.showConfirmDialog("Unarchive", "Unarchive", "Cancel", message, question ).subscribe(data => {
    if (data.action === 'OK') {
    var command = new UnarchiveCaseCommand(caseGuid);
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(command).subscribe(state => {
        this.invalidateSelectedTab();
        this.fuseSplashScreenService.hide();
    });
  }});
  }

  archive(event: any, value: boolean) {
    // console.log('Archived: ', event.item.cells['Archived'].value) ;
    if( value ){
      // Archive
      const dialogModel = DialogModel.create('Archive',
        'ArchiveUnarchiveDialogComponent',
        event , '600px', '700px');
      dialogModel.okCaption = 'Archive' ;
      this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(data => {
        if (data.action === 'OK') {
          this.fuseSplashScreenService.show();
          const command = new ArchiveFilingItemCommand(event.item.id, value);
          this.commandService.executeCommand(command).pipe().subscribe(commandState => {
            this.invalidateSelectedTab();
            this.fuseSplashScreenService.hide();
          });
        }
        else{
          this.invalidateSelectedTab();
        }
      });
    }
    else{
      // Unarchive
      const message = "You can unarchive this filing record if you need to make additional edits, or if it was archived by mistake. Please ensure that any associate Task and Reports are updated and re-opened as required.";
      const question = "Are you sure yoiu want to unarchive this filing record?";
      this.dialogService.showConfirmDialog("Unarchive", "Unarchive", "Cancel", message, question ).subscribe(data => {
        if (data.action === 'OK') {
          this.fuseSplashScreenService.show();
          const command = new ArchiveFilingItemCommand(event.item.id, value);
          this.commandService.executeCommand(command).pipe().subscribe(commandState => {
            console.log(commandState);
            this.invalidateSelectedTab();
            this.fuseSplashScreenService.hide();
          });
        }
      });
    }
  }

  bulkArchive(){
    let sourceKeyLower = this.sourceType.toLowerCase();//this.selectedTab.sourceKey.toLowerCase();magiclink
    let selectionKey = `${sourceKeyLower}-archive-cases`;
    let input = {
      ['SELECTION_KEY'] : selectionKey,
      ['ITEMS_SOURCE_TYPE']: this.sourceType///this.selectedTab.sourceKey magic link
    };
    let filterId = selectionKey;
    const basketSourceType = BasketProvider.getBasketMappedSourceType(this.sourceType)//this.selectedTab.sourceKey); magic link
    let preCommand = new SaveSelectedCaseModelsInLeftSideOfTheTransferboxCommand(selectionKey, filterId, basketSourceType);
    this.commandService.executeCommand(preCommand).subscribe(prestate=>{
      if(prestate){
        const dialogModel = DialogModel.create('Select', 'EntitySelectorDialogComponent', {
          filterId: selectionKey,
          filterTemplateId: `${sourceKeyLower}-archive-filter`,
          apiKey: 'Dac6Api',
          input: input
        });
        dialogModel.minWidth = '1200px';
        dialogModel.maxWidth = '1200px';
        dialogModel.okCaption = "Next";
        this.dialogService.showOkCancelDialog(dialogModel)
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe(actionState => {
            if (actionState && actionState.action === 'OK') {
              this.showArchiveDialog(filterId, selectionKey)
            }
          });
      }
    });
  }

  showArchiveDialog(filterId, selectionKey){
    const dialogModel = DialogModel.create('Archive Case(s)',
      'ArchiveDialogComponent',
      {}, '500px', '490px', false);
    dialogModel.okCaption = "Archive";
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(data => {
      if (data.action === 'OK') {
        console.log("Clicked Okay");
        console.log(data.data.input['comment']);
        let command = new ArchiveCaseCommand(filterId, selectionKey, this.sourceType/*this.selectedTab.sourceKey magiclink*/, data.data.input['comment']);
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).subscribe(state => {
          this.invalidateSelectedTab();
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }

  sendShowArchivedActivityCommand(tabSourceKey) {
    let showArchivedCommand = new PlatformCommand('ShowArchivedCommand','Dac6Api');
    var sourceKey = BasketProvider.getRootSourceKeyBySourceType(tabSourceKey);
    showArchivedCommand.fieldValues['SourceType'] = sourceKey;
    showArchivedCommand.fieldValues['IsArchived'] = this.showArchived;
    // viewDocumentCommand.fieldValues[sourceKey+"Id"] = event.item.id;
    this.commandService.executePlatformCommand(showArchivedCommand).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }

  sendCreateReportActivityCommand(sourceType,title,caseId) {
    let showArchivedCommand = new PlatformCommand('CreateReportActivityCommand','Dac6Api');
    var sourceKey = BasketProvider.getRootSourceKeyBySourceType(sourceType);
    showArchivedCommand.fieldValues['SourceType'] = sourceKey;
    showArchivedCommand.fieldValues['Title'] = title;
    showArchivedCommand.fieldValues['CaseId'] = caseId;
    // viewDocumentCommand.fieldValues[sourceKey+"Id"] = event.item.id;
    this.commandService.executePlatformCommand(showArchivedCommand).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }
  showArchivedChanged(command){
    this.fuseSplashScreenService.show();
    console.log("showArchivedChanged");
    this.showArchived = command.isChecked;
    let params = this.particleCacheService.getUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters,this.sourceType);
    params['SHOW_ARCHIVED'] = this.showArchived;
    this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters,this.sourceType, params);
    // for (var _i = 0; _i < this.tabs[this.currentBasketId].length; _i++) {
    //   var tab = this.tabs[this.currentBasketId][_i];
    //   const config = Configuration.getSmartGridConfig(tab.sourceKey);
    //   config['Parameters']['SHOW_ARCHIVED'] = this.showArchived;
    //   this.sendShowArchivedActivityCommand(tab.sourceKey);
    //   const gridParams = {...config.Parameters, 'SOURCE_TYPE': tab.sourceKey}
    //   this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, tab.sourceKey, gridParams);
    // }
    // magic link logic
    this.invalidateSelectedTab();
    this.fuseSplashScreenService.hide();
  }

  navigateToCaseFolder(event: any) {
    console.log('navigateToCaseFolder', event);
    if (event.action && event.action.tags.length) {
      let relativePath = event.action.tags[0];
      const caseId = event.item.cells['CaseId'].value;
      relativePath = relativePath.replace('[CASE_ID]', caseId);

      console.log('rellativePath', relativePath);
      this.fileStoreCommonService.navigateToClientFolderUsingRelativepath(relativePath);

    }
  }
  createReport(item: any) {
    const dialogModel = DialogModel.create('Add Report', 'AddReportComponent',
      {title: '', description: ''}
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(state => {
      if (state.action === 'OK') {
        this.commandService.executeCommand(new AddReportCommand(state.data.input.title, state.data.input.description))
          .pipe(take(1)).subscribe(commandState => {
          this.sendCreateReportActivityCommand(item.type,state.data.input.title,item.id);
          this.router.navigateByUrl(`dac6-reporter/reports/participants/${commandState.Payload.Id}/${item.id}`);
        });
      }
    });
  }
  goCorrespondingFilingTab(filingSourceType: string ) {
    // const tab = this.tabs[this.currentBasketId].find(o => o.sourceKey === filingSourceType);
    // this.selectTab(tab.index);
    const tab = this.magicLinkModel.tabBar.tabs.filter( o => o.id == filingSourceType)[0];
    this.setSelectedTab(tab);
  }

  createFiling() {
    let currentSelectedTab = this.tabs.filter(o => o.sourceKey === this.sourceType)[0];
    const dialogModel = DialogModel.create('Create Filing',
    currentSelectedTab['createFilingComponent'],//this.selectedTab['createFilingComponent'], will be set from magicLink
      {'caseType': 'Filing'}, '600px', '700px', true);
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe((data: any) => {
      if (data.action === 'OK') {
        if(!data.data.input.cancelFiling){
          this.goCorrespondingFilingTab(data.data.input.filingSourceType);
          //const command = new CreateFilingCommand(data.data.input.reportingCountryCode, data.data.input.formTemplateId, data.data.input.title,
          //  new Date(this.timeZoneService.dateTostringWithoutUTC(data.data.input.dueDate)));
          this.commandService.executeCommand(data.data.input['CreateFilingCommand']).pipe().subscribe(commandState => {
            console.log(commandState);
            this.invalidateSelectedTab();
          });
        }
      }
    });
  }
  close() {
    //this.isClose = true;
  }

  copyFilling(item: any){
    const dialogModel = DialogModel.create('Create Copy for Re-submission',
      'CopyFilingDialogComponent',
      {'title': item.cells.Title ? item.cells.Title.value + " (Re-submission)":''}, '600px', '700px', false);
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(data => {
      if (data.action === 'OK') {
        this.fuseSplashScreenService.show();
        const command = new CopyFilingCommand(item.id,data.data.input['isArchive'], true,data.data.input['title'], this.sourceType);//this.selectedTab.sourceKey); magic link
        this.commandService.executeCommand(command).pipe().subscribe(commandState => {
          console.log(commandState);
          this.invalidateSelectedTab();
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }

  private copyCase(event: any) {
    var dialogModelTitle = "Copy Case (" + event.item.cells.CaseId.displayText + ")";
    const dialogModel: DialogModel = DialogModel.create(
      dialogModelTitle,
      'CopyCaseDialogComponent', {'caseId': event.item.cells.CaseId.displayText, 'caseType': 'Filing', disableTypeChange: true, 'filedPeriodTitle': event.item.cells.FiledPeriodTitle.displayText, 'isReadOnly': event.item.isReadOnly, 'isArcived' : event.item.cells.Archived.value},
      '600px',
      '700px',
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log(res);
      if (res.action === 'OK') {
        switch (res.data.input.caseType) {
          case 'Filing':
            if (res.data.input.specifyField) {
              res.data.input['title'] = event.item.cells.Title.value;
              this.openSelectFieldDialog(res.data.input.selectedCase,'filingmodel', 'Dac6MonthlyFiling', res, event.item.id, res.data.input.copyCount);
            } else {
              this.copyFilingFromExistingCaseCommand(event.item.id , res.data.input.archiveExisting, res.data.input.caseIdUsedforCorrection, res.data.input.copyCount);
            }
            break;
        }
      }

    });
  }

  private openSelectFieldDialog(selectedCase: string, dbmodelType: string, sourceType: string, caseData: any, existingId: string, copyCount: number = 1) {
    const dialogModel: DialogModel = DialogModel.create(
      'Select Data',
      'VirtualGridDialogComponent', {sourceKey: 'Dac6-RowFieldData-Config', params: {'rowId': selectedCase, 'dbmodelType': dbmodelType, 'sourceType': sourceType}},
    );
    dialogModel.isFullscreen = true;
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        switch (sourceType) {
          case 'Dac6MonthlyFiling':
            this.copyFilingFromExistingCaseCommand(caseData.data.input.selectedCase, caseData.data.input.archiveExisting, false, caseData.data.input.copyCount, res.data.input.selectedFields, false);
            break;
        }
      }
    });
  }
  copyFilingFromExistingCaseCommand(existingCaseId: string, archiveExisting: boolean, caseIdForCorrection: boolean, copyCount: number, selectedFields?: string[], copyAllFields: boolean = true) {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new CopyFilingFromExistingCaseCommand(existingCaseId, archiveExisting, caseIdForCorrection, copyCount, selectedFields, copyAllFields)).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      this.invalidateSelectedTab();
    });
  }

  manageSection() {
    let sourceType = this.sourceType;
    const command = new PlatformCommand('CreateManageFieldMagicLinkCommand', Api.DAC6);
    command.fieldValues['SourceType'] = Configuration.getBasketMappedSourceType(sourceType);
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
      console.log('commandState', response);
      if (response.fieldValues['RedirectUrl']) {
        this.router.navigateByUrl(response.fieldValues['RedirectUrl']);
      }
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Failed to filing managesection ', error);
      });
  }
  onBasketChange(basket){
    // const currentBasket = BasketProvider.getCurrentBasket();
    // if(basket.id === currentBasket.id){
    //   return;
    // }
    // if(!this.isInitialBasket){
    //   this.adustFilterId(this.selectedTab.sourceKey);
    // }
    // this.isInitialBasket = false;

    // this.isTabDataLoaded = false;
    // this.currentBasket = event;
    // this.currentBasketId = this.currentBasket.id;
    // let tab = this.tabs[this.currentBasketId].find(o => o.filingType === this.selectedTab.filingType);
    // if (!tab) {
    //   tab = this.tabs[this.currentBasketId][0];
    // }
    // setTimeout(() => {
    //   this.selectTab(tab.index);
    //   this.isTabDataLoaded = true;
    //   this.navigateToFiling(tab.filingType);
    // }, 500);
    //magicLinkLogic
    if(this.magicLinkModel.fieldValues['CurrentBasket'].id !== basket.id) {
      const urlToken = this.router.url.split('?');
      const command = Dac6RoutingPlatformCommandHelper.getFilingPlatformLinkCommand();
      command.fieldValues['FilingType'] = this.activatedRoute.snapshot.params['FilingType'];
      command.fieldValues['QueryParameter'] = urlToken.length > 1 ? urlToken[1] : '';
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
         if (response.fieldValues['PlatformLinkModel']) {
           const payload = {
            id: 'PlatformToolContainerComponent',
            value: response.fieldValues['PlatformLinkModel']
          };
          this.magicLinkModel = response.fieldValues['PlatformLinkModel'];
          this.magicLinkModelValueChanged.emit(payload);
         }
      });
    }
  }
  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          } else {
            this.invalidateSubject.invalidate();
          }
        },
        error => {
          console.error('Failed ToolBarComponent command', error);
          this.fuseSplashScreenService.hide();
        });
    }
  }
  selectionChanged?($event: any): void {

  }
  onFieldSectionChanged?($event: any): void {

  }
  onFieldSectionIndexChanged?($event: any): void {

  }
}
